// This file is auto-generated by @hey-api/openapi-ts
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
/**
 * Confirmationurl
 * confirmationUrl
 * Display a html page with a confirmation message (called by  url callback from an email)
 * 1  test if the mail should be processed
 * 1.a test if the mail is in the "active" user base
 * 1.b test if the couple (key,mail) exists
 * 2.a.if this records exist and was created in the last 48 hours
 * 2.a.1 if it wasnt confirmed
 * 2.a.1.1 call the confirmAndCreateUser method
 * 2.a.1.2 send back "confirmed" in response
 * 2.a.2 else
 * 2.a.2.1 send back an "already confirm" response
 * 2.b else:
 * 2.b.1 send an error response " please register again"
 *
 *
 *
 *
 * Args:
 * key (str): encode utf8 hash
 * mail (str): encoded utf8 mail
 * @param data The data for the request.
 * @param data.key
 * @param data.mail
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const confirmationUrl = (data) => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/confirm/{key}/{mail}',
        path: {
            key: data.key,
            mail: data.mail
        },
        errors: {
            422: 'Validation Error'
        }
    });
};
/**
 * Verifytoken
 * verifyToken verify if a token is valide
 *
 * Args:
 * token (Annotated[str,Depends): jwt token
 * request (Request): request
 *
 * Returns:
 * _json_: json with token(jwtoken) and valide(bool) keys
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const verifyToken = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/verify'
    });
};
/**
 * Root
 * root :
 * point d'entrée API hello world
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const root = () => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/'
    });
};
/**
 * Login For Access Token
 * login_for_acces_token: point d'entrée HTTP pour récupérer un token sur /token
 * @ param:
 * form_data(OAuth2PasswordRequestForm) : objet contenant un champ username et champ password (spécifié par OAuth2)
 * @ return:
 * token(json) : jwt token au format json
 * @param data The data for the request.
 * @param data.formData
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const loginForAccessToken = (data) => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/token',
        formData: data.formData,
        mediaType: 'application/x-www-form-urlencoded',
        errors: {
            422: 'Validation Error'
        }
    });
};
/**
 * Readusersbyids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readUsersByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/users/ids/'
    });
};
/**
 * Readprofileathlete
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readProfileAthlete = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/users/athlete/'
    });
};
/**
 * Createuser
 * createUser
 * we wont use the token here but to avoid rewriting front end I let it this way.
 * Create a new user <-> ie register  a new user :
 * 1. call from frontend  from /register path with data (mail, password)
 * 2. create an registering_transacation records for that mail password with datetime and hash
 * 3. send a mail asking to confirm in the next 48 hours the registration
 *
 *
 * Args:
 * token (Annotated[str,Depends]): JWT
 * request (Request): with aquery param for user : email password,
 *
 * Returns:
 * dict: result of creation in registering_transaction table
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createUser = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/users/'
    });
};
/**
 * Updateuser
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateUser = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/users/'
    });
};
/**
 * Deleteuser
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteUser = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/users/'
    });
};
/**
 * Readuserbygroup
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readUserByGroup = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/user/group'
    });
};
/**
 * Updategroupforuser
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateGroupForUser = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/users/group'
    });
};
/**
 * Read Athletes By Ids
 * read_athletes_by_ids : retrieve etities athlete corresponding to the list passed in json parameter
 * @param :
 * token(jwt) : token de sécurité
 * request(Request) : request avec json comportant l'attribut id  à récupérer
 * @return :
 * json  syntaxe {"athletes" : ...}
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readAthletesByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/athletes/ids/'
    });
};
/**
 * Read Athlete By Name
 * read_athlete_by_name : retrieve a list of ahtlete where athleteName is like the string parameter (in json parameter)
 * @param :
 * token(jwt) : token
 * request(Request) : request with json paramert contening the string to macth against the athleteName
 * @ return:
 * json with token(jasonweb token) and athletes(list)  key
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readAthleteByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/athletes/name/'
    });
};
/**
 * Put Athlete
 * put_athlete : insert an athlete in a our database
 * EP  : /athletes/
 * @param:
 * token(jwt) : token
 * request(Request) : request with json with values for the athlete entity
 * @return:
 * json with key last_id last_params
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putAthlete = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/athletes/'
    });
};
/**
 * Update Athlete
 * update_athlete : update an athlete records
 *
 * Args:
 * token (Annotated[str,Depends): _description_
 * request (Request): _description_
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateAthlete = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/athletes/'
    });
};
/**
 * Delete Athlete
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteAthlete = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/athletes/'
    });
};
/**
 * Readtrainerforathlete
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readTrainerForAthlete = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/athletes/trainer/'
    });
};
/**
 * Createtrainerforathlete
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createTrainerForAthlete = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/athletes/trainer/'
    });
};
/**
 * Deletetrainerforathlete
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteTrainerForAthlete = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/athletes/trainer/'
    });
};
/**
 * Readtraineefortrainer
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readTraineeForTrainer = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/athletes/trainee/'
    });
};
/**
 * Read Teams By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readTeamsByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/teams/ids/'
    });
};
/**
 * Read Teams By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readTeamsByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/teams/name/'
    });
};
/**
 * Put Team
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putTeam = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/teams/'
    });
};
/**
 * Update Team
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateTeam = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/teams/'
    });
};
/**
 * Delete Team
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteTeam = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/teams/'
    });
};
/**
 * Read Composition By Team Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readCompositionByTeamIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/composition/teams/ids/'
    });
};
/**
 * Read Composition By Athlete Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readCompositionByAthleteIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/composition/athletes/ids/'
    });
};
/**
 * Create Composition
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createComposition = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/composition/'
    });
};
/**
 * Create Composition
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateCompositon = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/composition/'
    });
};
/**
 * Delete Composition
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteComposition = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/composition/'
    });
};
/**
 * Read Compositions Team Season
 * read_compositions_team_season retrieve a list of composition corresponding to the caracteristic of the datas parameter.
 * The data parameter should be a reprensentative "composition" record with idTeam and seasonStart fields.
 * We gather all the composition for a team and a season (a year).
 *
 * Args:
 * token (Annotated[str,Depends): JWT
 * request (Request): http request get
 *
 * Returns:
 * list[dict]: list of composition
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readCompositionsTeamSeason = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/composition/team/'
    });
};
/**
 * Read Composition Trainers
 * read_composition_trainers retrieve all the trainers from the list of compositions in datas
 *
 * Args:
 * token (Annotated[str,Depends): _description_
 * request (Request): GET HTTP request with list of ids or list of dict
 *
 * Returns:
 * list[dict]: _description_
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readCompositionTrainers = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/composition/trainer/'
    });
};
/**
 * Create Composition Trainer
 * create_composition_trainer create a composition for user
 * add a user as trainer for a composition, that would count for all the composition sharing the same team and seasonStart
 * Args:
 * token (Annotated[str,Depends): JWT
 * request (Request): HTTP put request with  composition fields
 *
 * Returns:
 * dict: trainer datas created
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createCompositionTrainer = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/composition/trainer/'
    });
};
/**
 * Create Trainer Composition
 * create_trainer_composition
 * create a new trainer for user based on a composition_trainer id : ie at least one trainer is already defined
 *
 *
 *
 * Args:
 * token (Annotated[str,Depends): JWT
 * request (Request): PUT http request with datas correspondingto the user and to anothere referenced trainer
 *
 * Returns:
 * dict: _description_
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createTrainerComposition = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/trainer/composition'
    });
};
/**
 * Read State Form By Ids
 * read_state_form_athletes : read state of form for athlates
 *
 * Args:
 * token (jwt):
 * request (Request): request with athlete datas in body as json representation of a dict
 *
 * Returns:
 * dict: token, result of fetch
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readStateFormByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/state_form/ids/'
    });
};
/**
 * Read State Form Athletes
 * read_state_form_athletes : read state of form for athlates
 *
 * Args:
 * token (jwt):
 * request (Request): request with athlete datas in body as json representation of a dict
 *
 * Returns:
 * dict: token, result of fetch
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readStateFormAthletes = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/state_form/athletes/'
    });
};
/**
 * Create State Form
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createStateForm = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/state_form/'
    });
};
/**
 * Create State Form
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createStateForm1 = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/state_form/'
    });
};
/**
 * Delete State Form
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteStateForm = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/state_form/'
    });
};
/**
 * Read Evaluation For Athletes
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readEvaluationForAthletes = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/evaluation/'
    });
};
/**
 * Read Evaluation For Athletes
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readEvaluationForAthletes1 = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/evaluation/'
    });
};
/**
 * Read Exercise By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readExerciseByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/exercise/ids/'
    });
};
/**
 * Read Exercise By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readExerciseByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/exercise/name/'
    });
};
/**
 * Create Exercise
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createExercise = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/exercise/'
    });
};
/**
 * Update Exercise
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateExercise = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/exercise/'
    });
};
/**
 * Delete Exercise
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteExercise = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/exercise/'
    });
};
/**
 * Read Exercise Type By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readExerciseTypeByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/exercise/type/ids/'
    });
};
/**
 * Read Exercise Type By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readExerciseTypeByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/exercise/type/name/'
    });
};
/**
 * Create Exercise Type
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createExerciseType = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/exercise/type/'
    });
};
/**
 * Update Exercise Type
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateExerciseType = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/exercise/type/'
    });
};
/**
 * Delete Exercise Type
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteExerciseType = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/exercise/type/'
    });
};
/**
 * Read Session By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readSessionByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/session/ids/'
    });
};
/**
 * Read Session By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readSessionByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/session/name/'
    });
};
/**
 * Read Session By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readSessionByName1 = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/session/athlete/'
    });
};
/**
 * Create Session
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createSession = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/session/'
    });
};
/**
 * Update Session
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateSession = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/session/'
    });
};
/**
 * Delete Session
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteSession = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/session/'
    });
};
/**
 * Read Injury By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readInjuryByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/injury/ids/'
    });
};
/**
 * Read Injury By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readInjuryByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/injury/name/'
    });
};
/**
 * Readinjuryforstateofform
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readInjuryForStateOfForm = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/injury/state_form/'
    });
};
/**
 * Create Injury
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createInjury = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/injury/'
    });
};
/**
 * Update Injury
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateInjury = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/injury/'
    });
};
/**
 * Delete Injury
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteInjury = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/injury/'
    });
};
/**
 * Read Test By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readTestByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/test/ids/'
    });
};
/**
 * Read Test By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readTestByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/test/name/'
    });
};
/**
 * Read Test For Session
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readTestForSession = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/test/session/'
    });
};
/**
 * Create Test
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createTest = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/test/'
    });
};
/**
 * Update Test
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateTest = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/test/'
    });
};
/**
 * Delete Test
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteTest = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/test/'
    });
};
/**
 * Read Pathology By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readPathologyByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/pathology/ids/'
    });
};
/**
 * Read Pathology By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readPathologyByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/pathology/name/'
    });
};
/**
 * Create Pathology
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createPathology = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/pathology/'
    });
};
/**
 * Update Pathology
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updatePathology = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/pathology/'
    });
};
/**
 * Delete Pathology
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deletePathology = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/pathology/'
    });
};
/**
 * Read Pain By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readPainByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/pain/ids/'
    });
};
/**
 * Create Pain
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createPain = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/pain/'
    });
};
/**
 * Update Pain
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updatePain = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/pain/'
    });
};
/**
 * Delete Pain
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deletePain = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/pain/'
    });
};
/**
 * Read Localisation By Ids
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readLocalisationByIds = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/localisation/ids/'
    });
};
/**
 * Read Localisation By Name
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const readLocalisationByName = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        query:{
            data:JSON.stringify(data),
        } ,
        method: 'GET',
        url: '/localisation/name/'
    });
};
/**
 * Create Localisation
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const createLocalisation = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'PUT',
        url: '/localisation/'
    });
};
/**
 * Update Localisation
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const updateLocalisation = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'POST',
        url: '/localisation/'
    });
};
/**
 * Delete Localisation
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteLocalisation = (token,data) => {
    return __request(OpenAPI, {
        headers: { "Authorization": "Bearer " + token },
        body: JSON.stringify(data),
        method: 'DELETE',
        url: '/localisation/'
    });
};
